import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Dictionary } from 'lodash';
import { Portal, UserContext } from 'src/app/core/models/portal.models';
import {
  PORTAL_CLEAR_DATA_CACHE,
  PORTAL_GET_ERROR,
  PORTAL_GET_SUCCESS,
  PORTAL_SAVE_SUCCESS,
  PORTAL_UPDATE_DATA_CACHE,
  PORTAL_UPDATE_JWT,
  PortalAction,
} from 'src/app/core/store/actions/portal';

export type PortalState = {
  readonly portal?: Portal;
  readonly depsCache: Dictionary<boolean>;
  readonly userContext?: UserContext;
};

export const initialState: PortalState = {
  portal: void 0,
  depsCache: {},
  userContext: void 0,
};

export function reducer(state = initialState, action: PortalAction): PortalState {
  switch (action.type) {
    case PORTAL_GET_SUCCESS: {
      return {
        ...state,
        portal: action.payload.portal,
        userContext: action.payload.userContext,
        depsCache: {},
      };
    }

    case PORTAL_UPDATE_JWT: {
      return {
        ...state,
        portal: {
          ...state.portal!,
          serviceToken: action.payload,
        },
      };
    }

    case PORTAL_GET_ERROR: {
      return {
        ...state,
        portal: void 0,
        depsCache: {},
      };
    }

    case PORTAL_UPDATE_DATA_CACHE: {
      return {
        ...state,
        depsCache: { ...state.depsCache, ...action.payload },
      };
    }

    case PORTAL_CLEAR_DATA_CACHE: {
      return {
        ...state,
        depsCache: {},
      };
    }

    case PORTAL_SAVE_SUCCESS: {
      return {
        ...state,
        portal: { ...action.payload },
        depsCache: {},
      };
    }

    default:
      return state;
  }
}

const getPortal = (state: PortalState) => state.portal;
const getUserContext = (state: PortalState) => state.userContext;
const getCache = (state: PortalState) => state.depsCache;
const getJWT = (state: PortalState) => state.portal?.serviceToken;

export const getPortalStateSelector = createFeatureSelector<PortalState>('portalState');
export const getPortalSelector = createSelector(getPortalStateSelector, getPortal);
export const getUserContextSelector = createSelector(getPortalStateSelector, getUserContext);
export const getJWTSelector = createSelector(getPortalStateSelector, getJWT);
export const getDepsCacheSelector = createSelector(getPortalStateSelector, getCache);
